import React, { Component } from 'react'
import Link from 'gatsby-link'
import '../../assets/stylesheets/left-navigation.scss'
import { MobileLogo } from './logo'
import xButton from '../../assets/images/x-button.svg'

function chunk(array, size) {
  const chunked_arr = []
  for (let i = 0; i < array.length; i++) {
    const last = chunked_arr[chunked_arr.length - 1]
    if (!last || last.length === size) {
      chunked_arr.push([array[i]])
    } else {
      last.push(array[i])
    }
  }
  return chunked_arr
}

class LeftNavigation extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isMenuOpen: false,
      isMenuHover: false,
      isMoreClickedMobile: false,
      transformAmt: 0,
      hideMore: false,
      hideArrow: true,
    }
  }

  updateDimensions = () => {
    this.menuClose()
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions)
  }

  menuOpen() {
    const { isMenuOpen } = this.state

    if (!isMenuOpen) {
      this.setState({
        isMenuOpen: true,
        isMenuHover: false,
      })
    }
  }

  menuClose() {
    this.setState({
      isMenuOpen: false,
    })
    this.scrollPrev()
    this.subClosed()
  }

  menuOver() {
    this.setState({
      isMenuHover: true,
    })
  }

  menuOut = () => {
    this.setState({
      isMenuHover: false,
    })
  }

  subOpen() {
    const { isMoreClickedMobile } = this.state

    if (!isMoreClickedMobile) {
      this.setState({
        isMoreClickedMobile: true,
      })
    }
  }

  subClosed() {
    this.setState({
      isMoreClickedMobile: false,
    })
  }

  scrollPrev = () => {
    this.setState({ transformAmt: 0, hideMore: false, hideArrow: true })
  }

  scrollToNext = () => {
    const cols = document.getElementsByClassName('sub-nav')
    const colCount = cols.length
    const { transformAmt } = this.state
    const newTransformAmt =
      transformAmt - cols[0].offsetWidth * 100 / window.innerWidth

    this.setState({
      transformAmt: newTransformAmt,
      hideMore:
        colCount - 2 ==
        Math.abs(
          transformAmt / (cols[0].offsetWidth * 100 / window.innerWidth)
        ),
      hideArrow: false,
    })
  }

  render() {
    const { projectLinks, pathname } = this.props
    const { isMenuHover, isMenuOpen, isMoreClickedMobile } = this.state
    const menuClass = isMenuHover ? 'menu-hover' : 'menu-out'
    const menuStateClass = isMenuOpen ? 'menu-open' : 'menu-closed'
    const subMenuClass = isMoreClickedMobile ? 'sub-open' : 'sub-closed'
    const windowGlobal = typeof window !== 'undefined' && window

    return (
      <div className={`${menuClass} ${menuStateClass}`} id="left-navigation">
        <Link to="/" onClick={this.menuClose.bind(this)}>
          <MobileLogo />
        </Link>
        <div
          className="wrapper"
          onMouseEnter={this.menuOver.bind(this)}
          onMouseLeave={this.menuOut.bind(this)}
          onClick={this.menuOpen.bind(this)}
        >
          <div className="image-mask">
            {isMenuOpen ? (
              <span onClick={this.menuClose.bind(this)}>
                <div className="button">
                  <span className="line verticle" />
                  <span className="line horizontal" />
                </div>
              </span>
            ) : (
              <span className="burger">
                <span className="bar top" />
                <span className="bar middle" />
                <span className="bar bottom" />
              </span>
            )}
          </div>

          <div className="image-mask-desktop">
            {isMenuOpen ? (
              <span onClick={this.menuClose.bind(this)}>
                <div className="button">
                  <img className="button close-icon" src={xButton} />
                </div>
              </span>
            ) : (
              <span className="desktop-title">Menu</span>
            )}
          </div>
        </div>
        <header>
          <nav className="menu">
            <ol className="primary-nav">
              <li className="work">
                <Link>
                  Work <br /> <span className="work-arrow">↓</span>
                </Link>
              </li>
              <li className="studio">
                <Link to="/studio" onClick={this.menuClose.bind(this)}>
                  About
                </Link>
              </li>
              <li className="contact">
                <Link
                  className="index"
                  to="/studio#contact"
                  onClick={this.menuClose.bind(this)}
                >
                  Contact
                </Link>
              </li>
            </ol>
            <div className={`menu-list  ${subMenuClass}`}>
              <div id="sc" className="slide-container">
                {chunk(
                  projectLinks,
                  windowGlobal.innerHeight > 650 ? 6 : 3
                ).map(list => (
                  <ol
                    className="sub-nav"
                    style={{
                      webkitTransform: `translate(${
                        this.state.transformAmt
                      }vw)`,
                      transition: 'transform 1s ease-in-out',
                    }}
                  >
                    {list.map((link, i) => (
                      <li
                        key={`NavItem_${i}`}
                        onClick={this.menuClose.bind(this)}
                      >
                        <Link to={`/case-study/${link.slug}/`}>
                          <span
                            dangerouslySetInnerHTML={{
                              __html: link.navigationDisplayTitle,
                            }}
                          />
                        </Link>
                      </li>
                    ))}
                  </ol>
                ))}
              </div>

              {!this.state.hideMore && (
                <button
                  className="more"
                  id="show-more"
                  onClick={this.scrollToNext.bind(this)}
                >
                  <span>
                    More <span className="plus">+</span>
                  </span>
                </button>
              )}

              {!this.state.hideArrow && (
                <span
                  id="show-arrow"
                  className="back-arrow"
                  onClick={this.scrollPrev.bind(this)}
                >
                  ↓
                </span>
              )}
            </div>
            <button className="more-mobile" onClick={this.subOpen.bind(this)}>
              <span className="more-tablet">More +</span>
            </button>
          </nav>
        </header>
        <button className="close-overlay" onClick={this.menuClose.bind(this)}>
          Close Menu
        </button>
        <div className="background" />
      </div>
    )
  }
}
export default LeftNavigation



// WEBPACK FOOTER //
// ./src/components/common/left-navigation.js